// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__39JHg","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2D9WE"};